/**
 * @file: 渲染主商品
 * @author: xiaolong.huang@dmall.com
 */

import * as Toolkit from '../../../toolkit/index';
import RenderData, { GoodsRenderData } from './renderData';
import CreateGoodsDom from './createGoodsDom';
import { loadingImg } from './loadingImg';

export function renderMainGoods(cube: CubeNode): void {
    // 组装商品渲染需要的数据
    let mainGoodsUIRenderData: GoodsRenderData = RenderData.mainGoods(cube);

    // 组装主商品dom对象
    let $mainGoods: JQuery<HTMLElement> = CreateGoodsDom(cube, mainGoodsUIRenderData);
    let $center: JQuery<HTMLElement> = cube.jView.find('.J_Center');

    Toolkit.html($center, '');
    $center.append($mainGoods);
    loadingImg($center);
}
